import axios from 'index/axios'

// 项目列表
export function getProjectList(data) {
    return axios.post('/ProjectManager/project/list', data)
}

// 项目详情
export function getProject(id) {
    return axios.get('/ProjectManager/project/detail', { id })
}

// 项目详情（别名）
export function getProjectDetail(id) {
    return axios.get('/ProjectManager/project/detail', { id })
}

// 新建项目
export function addProject(data) {
    return axios.post('/ProjectManager/project/add', data)
}

// 更新项目
export function updateProject(data) {
    return axios.post('/ProjectManager/project/update', data)
}

// 删除项目
export function deleteProject(id) {
    return axios.post('/ProjectManager/project/delete', { id })
}

// 成员列表
export function getProjectMembers(data) {
    return axios.post('/ProjectManager/project/member/list', data)
}

// 按角色分组的成员列表（含 jkd 角色名，Settings 专用）
export function getProjectMembersByRole(data) {
    return axios.post('/ProjectManager/project/member/listByRole', data)
}

// 添加成员
export function addProjectMember(data) {
    return axios.post('/ProjectManager/project/member/add', data)
}

// 更新成员
export function updateProjectMember(data) {
    return axios.post('/ProjectManager/project/member/update', data)
}

// 删除成员
export function deleteProjectMember(id) {
    return axios.post('/ProjectManager/project/member/delete', { Id: id })
}

// 项目问卷列表
export function getProjectForms(projectId) {
    return axios.get('/ProjectManager/project/forms', { projectId })
}

// 项目配额汇总
export function getProjectQuota(projectId) {
    return axios.get('/ProjectManager/project/quota', { projectId })
}

// 获取用户列表（用于添加成员选择）
export function getUserList(data) {
    return axios.post('/jkd/admin/users/userList', data || { Page: 1, Size: 999 })
}

// 代理-省-市-门店四级进度
export function getAgentHierarchyProgress(data) {
    return axios.post('/ProjectManager/project/getAgentHierarchyProgress', data)
}
